<script setup lang="ts">
import { ref } from "vue";

const props = defineProps<{
  linkText: string;
}>();

const showSlot = ref(false);

</script>

<template>
    <button
        class="link-button"
        @click.prevent="showSlot = !showSlot"
    >
        {{ props.linkText }}
    </button>
    <slot v-if="showSlot" />
</template>

<style scoped>
button {
  color: #165c69;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: #165c69;
  background-color: rgba(0,0,0,0);
  border: none;
}
</style>
